import type { ThemeInfoInterface } from '@/models'
import { config } from '@/config'
import { ref } from 'vue'

export const LIGHT_THEME_NAME = 'light'
export const DARK_THEME_NAME = 'dark'

const _defaultThemeInfo: ThemeInfoInterface = {
  id: LIGHT_THEME_NAME,
  name: 'Default',
  selected: false,
  icon: 'moon',
  iconWrapperColor: 'white',
  iconStrokeColor: 'blank',
  unavailable: false,
}

const getDefaultThemeId = () => {
  // Check if we are in a browser environment
  if (typeof window === 'undefined') {
    return LIGHT_THEME_NAME
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? DARK_THEME_NAME : LIGHT_THEME_NAME
}

const configThemes = config.themes || []

const availableThemes = (
  configThemes.length > 0
    ? configThemes
    : [
        {
          ..._defaultThemeInfo,
          selected: true,
        },
      ]
).filter((x) => !x.unavailable)

const refThemes = ref(availableThemes)

const setThemeIdOnDocumentElement = (themeId: string) => {
  const handler = () => {
    const documentElement = document.documentElement
    //documentElement.dataset.viewtransition = 'vertical'
    documentElement.dataset.theme = themeId
    // const classes = documentElement.className.split(' ').filter((x) => !x.endsWith('-theme'))
    // documentElement.className = [themeId, ...new Set(classes)].join(' ')
  }

  const doc = document as any
  if (doc.startViewTransition) {
    doc.startViewTransition(handler)
  } else {
    handler()
  }
}

const mutations = {
  restoreTheme() {
    let defaultThemeId: string = getDefaultThemeId()

    if (window && window.localStorage) {
      console.log('defaultThemeId', defaultThemeId, localStorage.getItem('theme'))
      defaultThemeId = (localStorage.getItem('theme') || defaultThemeId).toLowerCase()
      // if available...
      if (config.themes.some((x) => x.id.toLowerCase() === defaultThemeId)) {
        setThemeIdOnDocumentElement(defaultThemeId)
      }
    }

    refThemes.value.forEach((item: ThemeInfoInterface) => {
      if (item) {
        item.selected = item?.id.toLowerCase() === defaultThemeId
      }
    })
  },

  setNewTheme(themeId: string) {
    // @ts-ignore
    if (import.meta.browser && localStorage) {
      localStorage.setItem('theme', themeId)
      setThemeIdOnDocumentElement(themeId)
    }

    refThemes.value.forEach((item: ThemeInfoInterface) => {
      item.selected = item.id === themeId
    })
  },
}

const themes = computed((): ThemeInfoInterface[] => {
  return refThemes.value
})

const selectedTheme = computed((): ThemeInfoInterface => {
  const item = refThemes.value.find((x) => x.selected)
  if (!item) {
    return refThemes.value[0] as ThemeInfoInterface
  }
  return item as ThemeInfoInterface
})

export const useThemeStore = () => {
  return {
    restoreTheme: mutations.restoreTheme,
    setNewTheme: mutations.setNewTheme,
    selectedTheme,
    themes,
    availableThemes,
  }
}
